
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'cleanText',
    standalone: false
})
export class CleanTextPipe implements PipeTransform {
  transform(value: string, makeTitleCase = true): string {
    if (!value) return '';

    // Remove all special characters except space
    let cleaned = value.replace(/[^a-zA-Z0-9 ]/g, ' ');

    // Convert to Title Case if enabled
    if (makeTitleCase) {
      cleaned = cleaned.replace(
        /\w\S*/g,
        (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(),
      );
    }

    return cleaned;
  }
}

